export default {
  path: 'settings/products',
  name: 'TemporaryRegulationsProducts',
  component: () => import(/* webpackChunkName: "road-maintenance" */ '../views/ProductIndex.vue')
}
